import { render, staticRenderFns } from "./msgLogistics.vue?vue&type=template&id=2b24df2c&scoped=true&"
import script from "./msgLogistics.vue?vue&type=script&lang=js&"
export * from "./msgLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24df2c",
  null
  
)

export default component.exports